<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import ProfilePicture from '$lib/components/PFP.svelte'
	import { profile, user } from '$lib/stores/userData'

	import { XIcon, BadgeCheckIcon, BookmarkIcon } from '@rgossiaux/svelte-heroicons/outline'
	import { notification_bookmarks, newActivities } from '$lib/stores/notifications'
	import { page } from '$app/stores'
	import NewFeatureStar from '../NewFeatureStar.svelte'

	const dispatch = createEventDispatcher()
</script>

<XIcon class="h-8 menu-button absolute top-2 right-2" on:click={() => dispatch('close')} />
{#if $profile}
	<a
		on:click={() => dispatch('close')}
		href={$profile.username !== '' ? `/users/${$profile.username}` : `/profile`}
		class="flex py-4 justify-start items-center w-full"
	>
		<div class="shrink-0 w-32">
			<ProfilePicture profile={$profile} size={2} />
		</div>
		<div class="flex flex-col grow ml-5">
			<div class="text-lg font-bold">
				{$profile.name}
			</div>
			{#if $profile.username}
				<div>
					@{$profile.username}
				</div>
			{/if}
		</div>
	</a>
	{#if $profile.accountType && !$profile.accountType.includes('paid')}
		<menu-item-title>Action</menu-item-title>
		<a href={`/upgrade`} class="menu-item" on:click={() => dispatch('close')}>
			<div>Upgrade to premium</div>
			<BadgeCheckIcon class="h-6 text-green-500" />
		</a>
	{/if}
	<menu-item-title>Pages</menu-item-title>
	<a href={`/journals/summary`} class=" menu-item" on:click={() => dispatch('close')}>
		Year in review &nbsp;
		<NewFeatureStar/>
	</a>
	<a href={`/updates`} class=" menu-item" on:click={() => dispatch('close')}>
		Updates
		{#if $newActivities > 0}
			<span
				class="h-4 px-1 flex text-xs items-center justify-center rounded-full bg-red-500 text-white ml-2"
			>
				{$newActivities < 99 ? $newActivities : '99+'}
			</span>
		{/if}
	</a>
	<a href={`/users/all`} class="menu-item" on:click={() => dispatch('close')}> Browse Users </a>
	<a
		href="/saved"
		class="relative menu-item"
		on:click={() => {
			dispatch('close')
		}}
	>
		Saved <BookmarkIcon class="text-green-500 h-6" />
		{#if $notification_bookmarks > 0}
			<div
				class="h-4 w-4 flex text-xs items-center justify-center rounded-full bg-red-500 text-white absolute -left-2 "
			>
				{$notification_bookmarks}
			</div>
		{/if}
	</a>
	<menu-item-title>My Account</menu-item-title>
	<a
		href={`/profile`}
		class="menu-item"
		on:click={() => dispatch('close')}
	>
		Profile
	</a>

	{#if $page.data.user?.role === 'ADMIN'}
		<a href="/admin" class="menu-item" on:click={() => dispatch('close')}> Admin Console </a>
	{/if}

	<button
		class="menu-item"
		on:click={() => {
			console.log('logout')
			dispatch('logout')
		}}
	>
		Log out
	</button>
{/if}
